const moment = require('moment')
moment.locale('zh-cn')

module.exports = (value) => moment(value).fromNow()



// WEBPACK FOOTER //
// ./src/filter/time.js